/**
 * Страница менеджера: список заказов (manager/orders).
 *
 * Маркер инициализации — наличие .adm_req_table и таблицы заказов.
 * Используем уникальный hint — наличие "Payment status" в фильтре было бы шатко;
 * вместо этого ставим маркером сам контейнер #adm_r_brands_popup внутри adm_req_content
 * + проверка что мы НЕ на странице requests (там #requests-table).
 *
 * Функционал — поиск по таблице заказов.
 */

function init() {
    // Маркер: страница manager/orders отличается от других тем, что
    // тут есть .adm_req_content > #adm_r_brands_popup > .adm_req_table без id="requests-table"
    // и без id="messages-table". Простейший устойчивый маркер — body содержит
    // фильтр со статусом "Payment request".
    const filterCheckbox = document.querySelector('input[name="option_name"][value="Payment request"]');
    if (!filterCheckbox) return;

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-orders] jQuery not loaded');
        return;
    }

    $(() => {
        $('#adm_search_input').on('keyup', function () {
            const searchText = $(this).val().toLowerCase();
            $('.adm_req_table tbody tr').each(function () {
                const row = $(this);
                if (row.text().toLowerCase().indexOf(searchText) > -1) {
                    row.show();
                } else {
                    row.hide();
                }
            });
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
